export const UPLOAD_POLL_INTERVAL_MS = 1500;
export const UPLOAD_MAX_POLL_ATTEMPTS = 60;
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

export type UploadJobStatus =
  | 'pending'
  | 'waiting'
  | 'active'
  | 'completed'
  | 'failed';

export type UploadJobPollResult = {
  status: UploadJobStatus;
  url?: string;
  error?: string;
};

/** Let the browser set multipart boundary; apiClient defaults to application/json. */
export const multipartRequestConfig = {
  headers: { 'Content-Type': undefined as unknown as string },
};

export function assertImageFileSize(file: File): void {
  if (file.size > MAX_IMAGE_BYTES) {
    throw new Error('Image must be 5 MB or smaller.');
  }
}

export async function pollUploadJob(
  fetchStatus: () => Promise<UploadJobPollResult>,
): Promise<string> {
  for (let i = 0; i < UPLOAD_MAX_POLL_ATTEMPTS; i++) {
    const job = await fetchStatus();
    if (job.status === 'completed') {
      if (job.url) return job.url;
      throw new Error('Upload completed without a URL.');
    }
    if (job.status === 'failed') {
      throw new Error(job.error || 'Upload failed');
    }
    // waiting, active, pending — keep polling
    await new Promise((r) => setTimeout(r, UPLOAD_POLL_INTERVAL_MS));
  }
  throw new Error('Upload timed out');
}
